// extracted by mini-css-extract-plugin
export default {"skeleton__head":"styles_skeleton__head__s9T8v","skeleton__column":"styles_skeleton__column__qf6Tq","table__skeleton":"styles_table__skeleton__EhJ3D"};